
import { reactive, markRaw, ref } from 'vue';
import { useStore } from 'vuex';
import closeIcon from '@/assets/icons/close-icon.svg';
import PrimaryButton from '@/components/UI/PrimaryButton';
import Input from '@/components/UI/Input';
import catIcon from '@/assets/icons/cat-icon.svg';
import { INPUT_TYPE_ICON } from '@/config/newWallets';
import { findAddressWithNet, sortByAlphabet } from '@/helpers';

export default {
  name: 'CatPage',
  components: { catIcon, Input, PrimaryButton, closeIcon },
  props: {
    showModal: {
      type: Boolean,
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataQa: {
      type: [String, null],
      default: null,
    },
    walletTypePlaceholder: {
      type: String,
      default: 'Citadel One-Seed',
    },
    inputTypeIcon: {
      type: String,
      default: INPUT_TYPE_ICON.SEED,
    },
  },
  emits: ['close', 'buttonClick'],
  setup(props, { emit }) {
    const disabled = ref(false);
    const store = useStore();
    const aliases = reactive({});
    const icons = reactive({});
    props.data.map((wallet) => {
      aliases[`${wallet.net}_${wallet.address}`] = '';
      import(`@/assets/icons/networks/${wallet?.net}.svg`).then((val) => {
        icons[wallet?.net] = markRaw(val.default);
      });
    });

    const clickHandler = async () => {
      disabled.value = true;
      await Promise.all(
        props.data.map(async (wallet) => {
          if (!aliases[`${wallet.net}_${wallet.address}`]?.length) {
            return false;
          }
          await store.dispatch('wallets/renameWalletTitle', {
            walletId: findAddressWithNet(store.getters['wallets/wallets'], {
              address: wallet.address,
              net: wallet.net,
            })?.id,
            title: aliases[`${wallet.net}_${wallet.address}`],
          });
          return true;
        })
      );
      // if (renamed.filter((w) => w).length) {
      //   store.dispatch('wallets/getNewWallets','lazy');
      // }
      emit('buttonClick');
      disabled.value = false;
    };

    return { aliases, disabled, clickHandler, sortByAlphabet, icons };
  },
};
